import { crudPage } from '../../components/crud-page.js';
import { Clients } from '../../api/resources.js';

const TYPES = [
  { value: 'particular', label: 'Particular' },
  { value: 'empresa',    label: 'Empresa' },
  { value: 'recurrente', label: 'Recurrente' },
  { value: 'vip',        label: 'VIP' },
  { value: 'otro',       label: 'Otro' },
];

export default async function ClientsPage(outlet) {
  await crudPage(outlet, {
    title: 'Clientes',
    api: Clients,
    columns: [
      { key: 'full_name',   label: 'Nombre' },
      { key: 'document_id', label: 'Documento', render: (r) => r.document_id || '—' },
      { key: 'phone',       label: 'Telefono',  render: (r) => r.phone || '—' },
      { key: 'email',       label: 'Email',     render: (r) => r.email || '—' },
      { key: 'client_type', label: 'Tipo',      render: (r) => r.client_type || '—' },
    ],
    formFields: (item) => [
      { name: 'full_name',   label: 'Nombre',  value: item.full_name, required: true, full: true },
      { name: 'document_id', label: 'Documento de identidad', value: item.document_id },
      { name: 'phone',       label: 'Telefono', value: item.phone },
      { name: 'email',       label: 'Email', type: 'email', value: item.email },
      { name: 'client_type', label: 'Tipo', type: 'select', options: TYPES, value: item.client_type },
      { name: 'address',     label: 'Direccion', value: item.address, full: true },
      { name: 'notes',       label: 'Notas', value: item.notes, type: 'textarea', full: true },
    ],
  });
}
